<template>
  <div v-if="steps.length" class="approval-stepper">
    <div
      v-for="(step, index) in steps"
      :key="step.key"
      class="approval-stepper__item"
      :class="{
        'is-active': index === activeIndex,
        'is-done': index < activeIndex,
        'is-rejected': isRejected && index === activeIndex,
      }"
    >
      <div class="approval-stepper__marker">{{ index + 1 }}</div>
      <span class="approval-stepper__label">{{ step.label }}</span>
    </div>
  </div>
</template>

<script>
import { getApprovalStepperIndex, getApprovalStepperSteps, normalizeApprovalStatus } from "@/utils/approvalStatus";

export default {
  name: "ApprovalStepper",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    steps() {
      return getApprovalStepperSteps(this.item);
    },
    activeIndex() {
      return getApprovalStepperIndex(this.item);
    },
    isRejected() {
      return normalizeApprovalStatus(this.item?.status) === "rejected";
    },
  },
};
</script>

<style scoped>
.approval-stepper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.approval-stepper__item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #95aac9;
  font-size: 0.75rem;
}

.approval-stepper__marker {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #d2ddec;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  font-weight: 700;
}

.approval-stepper__item.is-done {
  color: #00d97e;
}

.approval-stepper__item.is-done .approval-stepper__marker {
  background: #00d97e;
  border-color: #00d97e;
  color: #fff;
}

.approval-stepper__item.is-active {
  color: #2c7be5;
  font-weight: 600;
}

.approval-stepper__item.is-active .approval-stepper__marker {
  background: #2c7be5;
  border-color: #2c7be5;
  color: #fff;
}

.approval-stepper__item.is-rejected {
  color: #e63757;
}

.approval-stepper__item.is-rejected .approval-stepper__marker {
  background: #e63757;
  border-color: #e63757;
  color: #fff;
}
</style>
